@if (open) {
  <div class="fixed inset-0 z-[1100] flex items-end justify-center p-0 sm:items-center sm:p-4" role="presentation">
    <div class="absolute inset-0 bg-slate-900/50 backdrop-blur-sm" (click)="closable && close()"></div>

    <div
      role="dialog"
      aria-modal="true"
      [attr.aria-label]="title || null"
      class="relative flex max-h-[92vh] w-full flex-col overflow-hidden rounded-t-2xl border border-gray-200 bg-white shadow-2xl sm:rounded-2xl dark:border-slate-700 dark:bg-slate-800"
      [class]="widthClass"
    >
      @if (title || closable) {
        <div class="flex items-center justify-between gap-3 border-b border-gray-100 px-5 py-4 dark:border-slate-700">
          <h5 class="m-0 text-lg font-semibold text-gray-900 dark:text-slate-100">{{ title }}</h5>
          @if (closable) {
            <app-brand-button variant="clear" icon="ic ic-times" ariaLabel="Close" (btnClick)="close()"></app-brand-button>
          }
        </div>
      }

      <div class="overflow-y-auto text-slate-700 dark:text-slate-200" [class.px-5]="padded" [class.py-5]="padded">
        <ng-content></ng-content>
      </div>

      <div class="border-t border-gray-100 px-5 py-4 empty:hidden dark:border-slate-700">
        <ng-content select="[modal-footer]"></ng-content>
      </div>
    </div>
  </div>
}
